<template>
  <div class="vz-wrapping-review">
    <vz-cargo-card
      v-for="(item, index) in wrapping"
      :key="index"
      class="vz-cargo-wrapping-card"
      :title="getTitle(index)"
      :editable-name="false"
      @remove="remove(item)"
    >
      <div class="vz-wrapping-review-input">
        <vz-input
          :modelValue="getWrappingItemName(item)"
          :disabled="isDimensionsMode || disabled"
          readonly
        >
          <template #label>
            <label
              class="vz-input-label fs-14"
              v-text="'Вид упаковки'"
            />
          </template>
        </vz-input>
        <vz-icon
          v-if="!isDimensionsMode"
          name="pencil"
          rounded
          :size="13"
          variant="white-gray-ws"
          class="vz-wrapping-review-input-edit"
          @click="showModal"
        />
      </div>
      <div
        v-if="!isNumeric(item) && !isDimensionsMode"
        class="vz-cargo-wrapping-card-places"
      >
        <div>Места</div>
        <vz-dropdown-checkbox
          :items="getItems(item.code)"
          :disabled="disabled"
          @change="changeWrappingPlace(item.code, false, $event)"
          @change-all="changeWrappingPlace(item.code, true, $event)"
        />
      </div>
    </vz-cargo-card>
  </div>
</template>

<script setup lang="ts">
import {PropType} from 'vue';
import {OrderWrappingItem} from '@/types/types';
import {useOrderStore} from '@/stores/order';
import {useWrappingStore} from '@/stores/wrapping';
import VzCargoCard from '@/components/personal/order/cargo/parts/vz-cargo-card.vue';
import VzDropdownCheckbox from '~/components/ui-kit/vz-dropdown-checkbox.vue';

const emit = defineEmits([
  'show-modal',
  'remove-item',
  'add-place',
  'remove-place'
])

const props = defineProps({
  wrapping: {
    type: Array as PropType<OrderWrappingItem[]>,
    default: () => ([])
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const orderStore = useOrderStore()
const wrappingStore = useWrappingStore()

const places = 'Для всех'

const isDimensionsMode = computed(() => {
  return orderStore.orderForm.cargo.mode === 'dimension'
})

function isNumeric(data: OrderWrappingItem) {
  let type = 'volume'
  let child
  wrappingStore.orderWrappingTypes.forEach((item) => {
    if (item.id) {
      child = item.list.find((childItem) => {
        return childItem.code === data.code
      })
      if (child) {
        type = child.type
      }
    } else if (item.list[0].code === data.code) {
      type = item.list[0].type
    }
  })
  return type === 'numeric'
}

function getTitle(index: number) {
  return `Упаковка ${index + 1}`
}

function getItems(code: string) {
  const items: { title: string, value: boolean }[] = []
  let codeWrapping
  orderStore.orderForm.cargo[orderStore.orderForm.cargo.mode].items.forEach((item, index) => {
    codeWrapping = item.wrapping.find((wrapping) => {
      return wrapping.code === code
    })
    items.push({ title: item.label || `Груз ${index + 1}`, value: Boolean(codeWrapping) })
  })
  return items
}

function getWrappingItemName(data: OrderWrappingItem) {
  let child
  let name = ''
  let parentName
  wrappingStore.orderWrappingTypes.forEach((item) => {
    if (item.id) {
      parentName = item.name
      child = item.list.find((childItem) => {
        return childItem.code === data.code
      })
      if (child) {
        name = `${parentName}, ${child.name}`
        if (child.type === 'numeric') {
          name += `, ${data.value} шт.`
        }
      }
    } else if (item.list[0].code === data.code) {
      name = item.list[0].name + (item.list[0].type === 'numeric' ? `, ${data.value} шт.` : '')
    }
  })
  return name
}

function showModal() {
  emit('show-modal')
}

function remove(item: OrderWrappingItem) {
  emit('remove-item', item.code)
}

function changeWrappingPlace(code: string, forAll: boolean, data: { status: boolean, index: number }): void {
  if (!isDimensionsMode.value) {
    if (data.status) {
      emit('add-place', { code, forAll, index: data?.index || 0 })
    } else {
      emit('remove-place', { code, forAll, index: data?.index || 0 })
    }
  }
}

</script>

<style lang="scss" scoped>
.vz-wrapping-review-input {
  position: relative;
  width: 100%;

  .vz-input-control {
    padding-right: 45px !important;
  }

  &-edit {
    position: absolute;
    right: 10px;
    bottom: 8px;
    padding: 5px !important;
  }
}
</style>
